import { Skeleton } from '@chakra-ui/react'
import { Loader } from '@components/layout/PageLayout'
import dynamic from 'next/dynamic'
import { ShimmerPostItem } from 'react-shimmer-effects'

const ProductGrid = dynamic(() => import('@components/product/product-grid'), {
  loading: () => <Loader />,
  ssr: false,
})

const SereneProductGrid = dynamic(
  () => import('@components/product/serene-product-grid'),
  {
    loading: () => <Loader />,
    ssr: false,
  },
)

const ElegantProductGrid = dynamic(
  () => import('@components/product/elegant-product-grid'),
  {
    loading: () => <Loader />,
    ssr: false,
  },
)

const ProductCard = dynamic(
  () => import('@components/product/product-cards/product-card'),
  {
    loading: () => <ShimmerPostItem card title cta imageHeight={305} />,
    ssr: false,
  },
)

const SereneProductCard = dynamic(
  () => import('@components/product/product-cards/serene-product-card'),
  {
    loading: () => <ShimmerPostItem card title cta imageHeight={305} />,
    ssr: false,
  },
)

const ElegantProductCard = dynamic(
  () => import('@components/product/product-cards/elegant-product-card'),
  {
    loading: () => <ShimmerPostItem card title cta imageHeight={305} />,
    ssr: false,
  },
)

const ProductPopup = dynamic(
  () => import('@components/product/product-popup'),
  {
    loading: () => (
      <Skeleton w="full" h={{ base: '920px', md: '1000px', lg: '680px' }} />
    ),
  },
)
const SereneProductPopup = dynamic(
  () => import('@components/product/serene-product-popup'),
  {
    loading: () => (
      <Skeleton w="full" h={{ base: '920px', md: '1000px', lg: '680px' }} />
    ),
  },
)
const ElegantProductPopup = dynamic(
  () => import('@components/product/elegant-product-popup'),
  {
    loading: () => (
      <Skeleton w="full" h={{ base: '920px', md: '1000px', lg: '680px' }} />
    ),
  },
)

const ProductDisplay = dynamic(() => import('@components/product/product'), {
  loading: () => (
    <Skeleton w="full" h={{ base: '920px', md: '1000px', lg: '680px' }} />
  ),
})
const SereneProductDisplay = dynamic(
  () => import('@components/product/serene-product-display'),
  {
    loading: () => (
      <Skeleton w="full" h={{ base: '920px', md: '1000px', lg: '680px' }} />
    ),
  },
)
const ElegantProductDisplay = dynamic(
  () => import('@components/product/elegant-product-display'),
  {
    loading: () => (
      <Skeleton w="full" h={{ base: '920px', md: '1000px', lg: '680px' }} />
    ),
  },
)

export const productGrids = {
  MINIMAL: ProductGrid,
  TRENDY: ProductGrid,
  ANTIQUE: ProductGrid,
  CLASSIC: ProductGrid,
  RETRO: ProductGrid,
  SERENE: SereneProductGrid,
  ELEGANT: ElegantProductGrid,
}

export const productCards = {
  MINIMAL: ProductCard,
  TRENDY: ProductCard,
  ANTIQUE: ProductCard,
  CLASSIC: ProductCard,
  RETRO: ProductCard,
  SERENE: SereneProductCard,
  ELEGANT: ElegantProductCard,
}

export const productPopups = {
  MINIMAL: ProductPopup,
  TRENDY: ProductPopup,
  ANTIQUE: ProductPopup,
  CLASSIC: ProductPopup,
  RETRO: ProductPopup,
  SERENE: SereneProductPopup,
  ELEGANT: ElegantProductPopup,
}

export const productDisplays = {
  MINIMAL: ProductDisplay,
  TRENDY: ProductDisplay,
  ANTIQUE: ProductDisplay,
  CLASSIC: ProductDisplay,
  RETRO: ProductDisplay,
  SERENE: SereneProductDisplay,
  ELEGANT: ElegantProductDisplay,
}
